export enum AuthMessages {
  ERROR_USE_CORPORATIVE_EMAIL = "Estimado Teclover 💙, inicia sesión con Google.",
  CANNOT_REFRESH_JWT = "No se ha podido recuperar tus credenciales, intenta iniciar sesión nuevamente.",
  COMPANY_NOT_FOUND = "No se ha encontrado la compañía o no existe.",
  ACCOUNT_NOT_FOUND = "La cuenta no existe contacte a un administrador del sistema.",
  ACCOUNT_DISABLED = "La cuenta ha sido deshabilitada por el administrador del sistema.",
  INVALID_COMPANY = 'La empresa no se ha encontrado en el sistema.'
}
